import './PuxModal.scss'

import Modal from '@material-ui/core/Modal'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import React, { FunctionComponent } from 'react'

import CloseIcon from '../PuxIconBuilder/Icons/CloseIcon'

interface PuxModalType {
  id: string
  variant?: 'default' | 'slim'
  children: React.ReactNode
}

const rootClass = `Modal`

export const getModalTriggerId = (id?: string): string => {
  return typeof id === `string` ? `modal-trigger-${id}` : `missing-trigger-id`
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      position: `absolute`,
      width: 1180,
      backgroundColor: theme.palette.background.paper,
      boxShadow: `7px 7px 50px rgba(80, 89, 111, 0.3)`,
      padding: theme.spacing(2, 4, 3),
    },
  })
)

const PuxModal: FunctionComponent<PuxModalType> = (props) => {
  const classes = useStyles()
  const [open, setOpen] = React.useState(false)
  const variant = props.variant === `slim` ? `slim` : `default`
  const variantClass = `${rootClass}--${variant}`
  const closeIconColor =
    variant === `slim`
      ? { colorPrimary: `#8088C3` }
      : { colorPrimary: `#0080ff` }
  const closeIconHoverColor =
    variant === `slim`
      ? { colorPrimary: `#8088C3` }
      : { colorPrimary: `#50596f` }

  const handleClose = () => {
    setOpen(false)
  }

  const handleOpen = () => {
    if (typeof document !== `undefined`) {
      if (window.dataLayer) {
        window.dataLayer.push({
          event: `openmodal`,
        })
      }
    }
    setOpen(true)
  }

  return (
    <div className={`${rootClass} ${variantClass}`}>
      <Modal
        className={`${rootClass}-dialog ${variantClass}`}
        open={open}
        onClose={handleClose}
      >
        <div className={`${rootClass}-paper ${classes.paper}`}>
          <button
            type='button'
            className={`${rootClass}-close`}
            onClick={handleClose}
            aria-label='Close modal'
          >
            <CloseIcon
              color={closeIconColor}
              hoverColor={closeIconHoverColor}
            />
          </button>
          <div className={`${rootClass}-content`}>{props.children}</div>
        </div>
      </Modal>

      <button
        className={`${rootClass}-trigger`}
        onClick={() => handleOpen()}
        id={getModalTriggerId(props.id)}
      >
        Open
      </button>
    </div>
  )
}

export default PuxModal
